import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import MapView from '@arcgis/core/views/MapView';
import Basemap from '@arcgis/core/Basemap';
import BasemapGallery from '@arcgis/core/widgets/BasemapGallery';

@Component({
  selector: 'app-basemap-gallery-widget',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './basemap-gallery-widget.component.html',
  styleUrls: ['./basemap-gallery-widget.component.scss']
})
export class BasemapGalleryWidgetComponent implements OnInit {

  @Input('view') mapview!: MapView;
  @ViewChild('basemapGalleryDiv', { static: true }) private mapGalleryRef!: ElementRef;

  constructor(public elem: ElementRef) { }

  private streetsBaseMap = new Basemap({
    portalItem: {
      id: "09052b3b734e436aa0afc53a49e84738"
    }
  })

  private nightBaseMap = new Basemap({
    portalItem: {
      id: "f2c218e832cb4d72aa449b547d7ae777"
    }
  })

  private greyBaseMap = new Basemap({
    portalItem: {
      id: "f851c4b0d98642318de33d42866a2cfd"
    }
  })


  ngOnInit() {
    const view = this.mapview;  
    new BasemapGallery({
      view: view,
      container: this.mapGalleryRef.nativeElement,
      source: [this.greyBaseMap, this.nightBaseMap, this.streetsBaseMap]
    });



  }


}
